// extracted by mini-css-extract-plugin
var _1 = "IntegrationLoginButton-module__buttonIconText--YWdni";
var _2 = "IntegrationLoginButton-module__container--aixXd";
var _3 = "IntegrationLoginButton-module__github--yO6hs";
var _4 = "IntegrationLoginButton-module__google--dtUUi";
var _5 = "IntegrationLoginButton-module__microsoft--ascQA";
var _6 = "IntegrationLoginButton-module__okta--REKji";
var _7 = "IntegrationLoginButton-module__onelogin--HuMzU";
var _8 = "IntegrationLoginButton-module__slack--fKhrc";
export { _1 as "buttonIconText", _2 as "container", _3 as "github", _4 as "google", _5 as "microsoft", _6 as "okta", _7 as "onelogin", _8 as "slack" }
